<script>
import Post from 'macarons-blog/Post.vue'
import {GrantedCondition} from 'macarons'

export default {
  extends: Post,
  data () {
    return {
      displayTitle: true,
      canEdit: false
    }
  },
  mounted () {
    this.$emit('titleChange', '')
    this.$store.dispatch('isGranted', {
      attribute: 'edit',
      subject: 'YWC\\MacaronsBlogBundle\\Entity\\Post'
    }).then(canEdit => {
      this.canEdit = canEdit
      this.setMenu()
    })
  },
  watch: {
    displayTitle () {
      if (this.article !== null) {
        this.$emit('titleChange', this.displayTitle ? this.article.title : '')
      }
      this.setMenu()
    },
    article () {
      if (this.article !== null) {
        this.$emit('titleChange', this.displayTitle ? this.article.title : '')
      }
    }
  },
  methods: {
    setMenu () {
      const editCondition = new GrantedCondition('edit', 'AppBundle\\Entity\\Macarons\\Widget')
      editCondition.resolve().then(grant => {
        if (grant) {
          const menu = [
            this.displayTitle ? {
              label: 'Masquer le titre',
              value: this.toggleTitle
            } : {
              label: 'Afficher le titre',
              value: this.toggleTitle
            }
          ]
          if (this.canEdit) {
            menu.push({label: 'Éditer', value: this.edit})
          }
          this.$emit('menuChange', menu)
        }
      })
    },
    toggleTitle () {
      this.displayTitle = !this.displayTitle
    },
    edit () {
      this.$router.push('/static/admin/' + this.article.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/blog/BlogPost.vue